module.exports = __webpack_public_path__ + "static/img/title.65fa8d59.png";